<div class="website-content" style="max-width:72rem;padding:0 var(--wa-spacing-x-large) var(--wa-spacing-x-large) var(--wa-spacing-x-large);">
	<div class="wa-stack wa-gap-xl">
		<wa-button [routerLink]="['/plugins']" appearance="plain" variant="neutral">Back to Plugins</wa-button>
		<wa-card appearance="outlined">
			<div class="wa-stack wa-gap-m">
				<div class="wa-stack wa-gap-s">
					<h1 waHeading="xl" waText>Toastr</h1>
					<p waBody="m" waText>Toastr &mdash; non-blocking notification toasts with 4 types &#40;Info, Success, Warning, Error&#41;, 8 screen positions, configurable easing animations, progress bar, close button, and duplicate prevention. Lightweight, customizable toast messages with CRTP fluent Java API.</p>
					<div class="wa-cluster wa-gap-xs">
						<wa-tag pill variant="neutral">Java 25+</wa-tag>
						<wa-tag pill variant="neutral">Toastr 2.1.4</wa-tag>
						<wa-tag pill variant="neutral">Angular 21</wa-tag>
						<wa-tag pill variant="neutral">JPMS Modular</wa-tag>
					</div>
				</div>
				<wa-divider></wa-divider>
				<div class="wa-stack wa-gap-xs">
					<div waCaption="s" waFontWeight="semibold" waText>COORDINATES &amp; MODULE</div>
					<p waBody="s" waText>Maven: com.jwebmp.plugins:toastr</p>
					<p waBody="s" waText>JPMS Module: com.jwebmp.plugins.toastr</p>
					<p waBody="s" waText>Built on: Toastr 2.1.4</p>
				</div>
				<wa-details summary="Installation">
					<div class="wa-stack wa-gap-xs">
						@if (!useGradle) {
							<div class="code-block-wrapper">
								<div class="code-block-label" waCaption="s" waFontWeight="semibold" waText>Maven</div>
								<markdown [data]="mdContent_657" class="aside-snippet-code wa-body-s" clipboard lineNumbers></markdown>
							</div>
						}
						@if (useGradle) {
							<div class="code-block-wrapper">
								<div class="code-block-label" waCaption="s" waFontWeight="semibold" waText>Gradle &#40;Kotlin DSL&#41;</div>
								<markdown [data]="mdContent_658" class="aside-snippet-code wa-body-s" clipboard lineNumbers></markdown>
							</div>
						}
					</div>
				</wa-details>
				<wa-details summary="NPM Dependencies (auto-included)">
					<markdown [data]="mdContent_659" class="aside-snippet-code wa-body-s" clipboard lineNumbers></markdown>
				</wa-details>
				<wa-divider></wa-divider>
				<div class="wa-stack wa-gap-m">
					<h2 waHeading="l" waText>Components &#40;5&#41;</h2>
					<p waBody="m" waText>Click any component to see its full API &mdash; properties, constructors, methods, events, slots, and examples.</p>
					<div class="wa-grid wa-gap-s" style="--min-column-size:18rem;">
						<wa-card appearance="outlined">
							<div class="wa-stack wa-gap-xs">
								<h4 waHeading="s" waText>ToastrFeature</h4>
								<p waBody="s" waColorText="quiet" waText>Main toast feature component &mdash; creates non-blocking notification toasts with configurable type, title, message, and options. Extends Feature with CRTP fluent API.</p>
								<div class="wa-cluster wa-gap-xs">
									<wa-tag pill variant="brand">3 props</wa-tag>
									<wa-tag pill variant="neutral">7 methods</wa-tag>
									<wa-tag pill variant="success">3 examples</wa-tag>
								</div>
								<wa-button [routerLink]="['/plugins/toastr/toastr-feature']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
							</div>
						</wa-card>
						<wa-card appearance="outlined">
							<div class="wa-stack wa-gap-xs">
								<h4 waHeading="s" waText>ToastrOptions</h4>
								<p waBody="s" waColorText="quiet" waText>CRTP options class for toast configuration &mdash; positioning, timing, animations, and behavior. All setters return J for fluent chaining.</p>
								<div class="wa-cluster wa-gap-xs">
									<wa-tag pill variant="brand">15 props</wa-tag>
								</div>
								<wa-button [routerLink]="['/plugins/toastr/toastr-options']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
							</div>
						</wa-card>
						<wa-card appearance="outlined">
							<div class="wa-stack wa-gap-xs">
								<h4 waHeading="s" waText>ToastrType</h4>
								<p waBody="s" waColorText="quiet" waText>Enum of 4 toast notification types with distinct visual styling.</p>
								<div class="wa-cluster wa-gap-xs">
									<wa-tag pill variant="brand">4 props</wa-tag>
								</div>
								<wa-button [routerLink]="['/plugins/toastr/toastr-type']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
							</div>
						</wa-card>
						<wa-card appearance="outlined">
							<div class="wa-stack wa-gap-xs">
								<h4 waHeading="s" waText>ToastrPosition</h4>
								<p waBody="s" waColorText="quiet" waText>Enum of 8 screen positions for toast placement.</p>
								<div class="wa-cluster wa-gap-xs">
									<wa-tag pill variant="brand">8 props</wa-tag>
									<wa-tag pill variant="neutral">1 methods</wa-tag>
								</div>
								<wa-button [routerLink]="['/plugins/toastr/toastr-position']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
							</div>
						</wa-card>
						<wa-card appearance="outlined">
							<div class="wa-stack wa-gap-xs">
								<h4 waHeading="s" waText>ToastrPageConfigurator</h4>
								<p waBody="s" waColorText="quiet" waText>Auto-configuration that registers toastr npm package, JS script, and CSS stylesheet via Angular build annotations.</p>
								<div class="wa-cluster wa-gap-xs">
									<wa-tag pill variant="neutral">2 methods</wa-tag>
									<wa-tag pill variant="success">1 examples</wa-tag>
								</div>
								<wa-button [routerLink]="['/plugins/toastr/toastr-page-configurator']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
							</div>
						</wa-card>
					</div>
				</div>
				<wa-details summary="Features (12)">
					<div class="wa-stack wa-gap-xs">
						<p waBody="s" waColorText="quiet" waText>Non-blocking notifications &mdash; lightweight toast messages that don't interrupt user flow</p>
						<p waBody="s" waColorText="quiet" waText>4 toast types &mdash; Info, Success, Warning, Error with distinct styling</p>
						<p waBody="s" waColorText="quiet" waText>8 screen positions &mdash; top/bottom &times; left/center/right/full-width</p>
						<p waBody="s" waColorText="quiet" waText>Progress bar &mdash; optional countdown progress indicator</p>
						<p waBody="s" waColorText="quiet" waText>Close button &mdash; optional close button on toasts</p>
						<p waBody="s" waColorText="quiet" waText>Duplicate prevention &mdash; configurable deduplication of identical toasts</p>
						<p waBody="s" waColorText="quiet" waText>Easing animations &mdash; customizable show/hide easing effects via JQ Easing Effects</p>
						<p waBody="s" waColorText="quiet" waText>Configurable timeouts &mdash; show duration, hide duration, timeout, and extended timeout</p>
						<p waBody="s" waColorText="quiet" waText>HTML escaping &mdash; optional HTML entity escaping for message content</p>
						<p waBody="s" waColorText="quiet" waText>CRTP fluent API &mdash; type-safe method chaining for toast configuration</p>
						<p waBody="s" waColorText="quiet" waText>Zero configuration &mdash; auto-registered via ServiceLoader SPI</p>
						<p waBody="s" waColorText="quiet" waText>Angular integration &mdash; auto-loaded via &#64;TsDependency, &#64;NgScript, &#64;NgStyleSheet</p>
					</div>
				</wa-details>
				<wa-divider></wa-divider>
				<wa-details open summary="Examples (2)">
					<div class="wa-stack wa-gap-m">
						<div class="wa-stack wa-gap-xs">
							<h4 waHeading="s" waText>Simple toast notification</h4>
							<p waBody="s" waColorText="quiet" waText>Show different types of toast messages.</p>
							<markdown [data]="mdContent_660" class="aside-snippet-code wa-body-s" clipboard lineNumbers></markdown>
						</div>
						<div class="wa-stack wa-gap-xs">
							<h4 waHeading="s" waText>Customized positioning and timing</h4>
							<p waBody="s" waColorText="quiet" waText>Configure toast position, duration, and animation.</p>
							<markdown [data]="mdContent_661" class="aside-snippet-code wa-body-s" clipboard lineNumbers></markdown>
						</div>
					</div>
				</wa-details>
				<wa-details open summary="Quick Start">
					<markdown [data]="mdContent_662" class="aside-snippet-code wa-body-s" clipboard lineNumbers></markdown>
				</wa-details>
				<wa-divider></wa-divider>
				<wa-details open summary="SPI Extension Point Details (2)">
					<div class="wa-stack wa-gap-s">
						<div class="wa-stack wa-gap-xs">
							<div class="wa-cluster wa-gap-xs">
								<wa-tag pill variant="success">IPageConfigurator</wa-tag>
								<wa-tag pill variant="neutral">provides</wa-tag>
							</div>
							<p waBody="s" waColorText="quiet" waText>ToastrPageConfigurator auto-registers toastr JS/CSS via npm with &#64;TsDependency, &#64;NgScript, and &#64;NgStyleSheet</p>
						</div>
						<div class="wa-stack wa-gap-xs">
							<div class="wa-cluster wa-gap-xs">
								<wa-tag pill variant="success">IGuiceScanModuleInclusions</wa-tag>
								<wa-tag pill variant="neutral">provides</wa-tag>
							</div>
							<p waBody="s" waColorText="quiet" waText>ToastrInclusionsModule registers the toastr module for Guice classpath scanning</p>
						</div>
					</div>
				</wa-details>
				<wa-details open summary="SPI Extension Points">
					<div class="wa-stack wa-gap-xs">
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="success">provides IPageConfigurator</wa-tag>
							<wa-tag pill variant="success">provides IGuiceScanModuleInclusions</wa-tag>
						</div>
					</div>
				</wa-details>
				<wa-divider></wa-divider>
				<wa-details open summary="Prerequisites">
					<div class="wa-cluster wa-gap-xs">
						<wa-tag pill variant="neutral">Java 25 LTS</wa-tag>
						<wa-tag pill variant="neutral">Maven 3.9+</wa-tag>
						<wa-tag pill variant="neutral">Node.js 18+</wa-tag>
						<wa-tag pill variant="neutral">Angular 21+</wa-tag>
					</div>
				</wa-details>
				<wa-divider></wa-divider>
				<div class="wa-cluster wa-gap-s">
					<wa-tag pill variant="neutral">Upstream: http://codeseven.github.io/toastr/</wa-tag>
					<wa-tag pill variant="neutral">Source: https://github.com/JWebMP/Toastr</wa-tag>
				</div>
			</div>
		</wa-card>
	</div>
</div>